module.exports = {
  city: {
    name: "高雄市",
    districtNum: "38",
    govURL: "https://www.kcg.gov.tw/",
    healthURL: "https://health.kcg.gov.tw/",
    addresses: [
      {
        address: "802511 高雄市苓雅區凱旋二路132-1號",
        phone: "(07)7134000",
      },
    ],
    style: {
      "--home-bar-background": "#0f4c81",
      "--home-header-background": "#fff",
      "--home-title-text": "#D32F2F",
      "--home-subtitle-text": "#0D47A1",
      "--home-subtitle-background": "#b2ebf2",
      "--home-image-overlay": "#000",
    },
  },
	apiURL: `https://healthscreening.kchb.gov.tw/api`,
  notHttpsApiURL: `https://healthscreening.kchb.gov.tw/api`,
  surveyURL: `https://healthscreening.kchb.gov.tw/survey`,
  surveySatisfactionURL: ``,
};
